import React, { Component } from 'react';
import { connect } from "react-redux";
import { Field, reduxForm } from 'redux-form';

import { employeeEnableClicked, inviteEmployee } from '../../redux/actions';

import { toArray } from "../assets/util";
import ProfilePic from '../atoms/profilePic/profilePic';
import Button from '../atoms/button/button';
import EmptyState from '../molecules/emptyState/emptyState';
import SideModal from '../molecules/modal/sideModal';
import { ListEmployees, ListInvites } from '../molecules/listItems/listItems';
import { AddField } from '../atoms/formElements/formElements';

class Employees extends Component {
  renderInviteList() {
    const { invites, user } = this.props;
    if(invites && invites.length > 0 && user && user.admin) {
      invites.sort((a, b) => {
          if(a.email < b.email) { return -1; }
          if(a.email > b.email) { return 1; }
          return 0;
      })
      return invites.map((employee, key) => {
        return <ListInvites key={key} employee={employee} />
      })
    }
  }
  renderEmployeeList() {
    const { employees, user } = this.props;
    if(employees && employees.length > 0 && user && user.admin) {
      employees.sort((a, b) => {
          if(a.nameL < b.nameL) { return -1; }
          if(a.nameL > b.nameL) { return 1; }
          return 0;
      })
      return employees.map((employee, key) => {
        return <ListEmployees key={key} employee={employee} onClick={() => this.props.employeeEnableClicked(employee)} />
      })
    } else {
      return <EmptyState title='No employees added yet' text='After adding employees you can choose to enable or disable their account here.' />
    }
  }
  formSubmit = (values) => {
    this.props.inviteEmployee(values.email);
  }
  render() {
    const { state, handleSubmit } = this.props

    return (
      <SideModal active={state ? 'active' : null } screen='employees' >
        <div id='sideModalWrapper'>
          <h1>Employees</h1>
          <form className='addForm' onSubmit={handleSubmit(this.formSubmit)}>
            <span className='mdi mdi-plus left' />
            <Field name='email' label='Email' component={AddField} type='text' placeholder='ex. johndoe@gmail.com' />
            <Button label='Add' disabled='false' type='submit' />
          </form>
          <div className='employeesList'>
            {this.renderInviteList()}
            {this.renderEmployeeList()}
          </div>
        </div>
      </SideModal>
    )
  }
}

function mapStateToProps(state) {
  let invites = null;
  if(state.firestore && state.firestore.data && state.firestore.data.customers && state.firestore.data.customers[state.general.company.customerId]) {
    invites = state.firestore.data.customers[state.general.company.customerId].invites
  }
  return {
    employees: state.employees,
    user: state.general.user,
    state: state.overlays.employees,
    invites: toArray(invites),
   }
}

export default reduxForm({
  // validate,
  form: 'inviteForm',
})( connect(mapStateToProps, { employeeEnableClicked, inviteEmployee })(Employees));
